import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/views/index/index.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'indexLab',
  component: index
},
{
  path: '/login',
  name: 'loginIndex',
  component: () => import(/* webpackChunkName: "login" */ '@/views/index/login.vue')
},
{
  path: '/manage',
  name: 'manageIndex',
  component: () => import(/* webpackChunkName: "manage" */ '@/views/index/manage.vue')
},
{
  path: '/overview',
  name: 'overviewIndex',
  component: () => import(/* webpackChunkName: "overview" */ '@/views/overview')
},
{
  path: '/dynamic',
  name: 'dynamicIndex',
  component: () => import(/* webpackChunkName: "dynamic" */ '@/views/dynamic/index.vue')
},
{
  path: '/dynamic/news',
  name: 'dynamicNews',
  component: () => import(/* webpackChunkName: "dynamic" */ '@/views/dynamic/news.vue')
},
{
  path: '/research',
  name: 'researchIndex',
  component: () => import(/* webpackChunkName: "research" */ '@/views/research/index.vue')
},
{
  path: '/research/detail',
  name: 'derectionDetail',
  component: () => import(/* webpackChunkName: "research" */ '@/views/research/detail.vue')
},
{
  path: '/platform',
  name: 'platformIndex',
  component: () => import(/* webpackChunkName: "platform" */ '@/views/platform/index.vue')
},
{
  path: '/platform/detail',
  name: 'platformDetail',
  component: () => import(/* webpackChunkName: "platform" */ '@/views/platform/detail.vue')
},
{
  path: '/alumnus',
  name: 'alumnusIndex',
  component: () => import(/* webpackChunkName: "alumnus" */ '@/views/alumnus/index.vue')
},
{
  path: '/alumnus/detail',
  name: 'alumnusDetail',
  component: () => import(/* webpackChunkName: "alumnus" */ '@/views/alumnus/detail.vue')
},
{
  path: '/graduate',
  name: 'graduateIndex',
  component: () => import(/* webpackChunkName: "graduate" */ '@/views/graduate/index.vue')
},
{
  path: '/graduate/detail',
  name: 'graduateDetail',
  component: () => import(/* webpackChunkName: "graduate" */ '@/views/graduate/detail.vue')
},
{
  path: '/search',
  name: 'searchIndex',
  component: () => import(/* webpackChunkName: "search" */ '@/views/search/index.vue')
},
{
  path: '/student',
  name: 'studentIndex',
  component: () => import(/* webpackChunkName: "student" */ '@/views/student/index.vue')
},
{
  path: '/student/detail',
  name: 'studentDetail',
  component: () => import(/* webpackChunkName: "student" */ '@/views/student/detail.vue')
}
]

// 标识当前导航，使上一次后退的滚动校正在新跳转发生时立即失效
let navToken = 0

const router = new VueRouter({
  routes,
  // 滚动行为：
  // savedPosition 只在浏览器前进/后退（popstate）时有值；
  // 点击页面里的链接跳转（$router.push）时 savedPosition 为 null
  scrollBehavior (to, from, savedPosition) {
    navToken++

    // 点击链接跳转到新页面：回到顶部
    if (!savedPosition) {
      return { x: 0, y: 0 }
    }

    // 浏览器后退：恢复到离开时的位置。页面在 mounted 里异步请求数据、
    // 图片懒加载会让高度变化，立即 scrollTo 会被截断到错误位置，
    // 故延迟并多次校正，直到内容稳定
    const token = navToken
    return new Promise(resolve => {
      const apply = (attempt) => {
        // 期间发生了新跳转，停止校正，避免覆盖新页面的滚动位置
        if (token !== navToken) {
          resolve()
          return
        }
        window.scrollTo(savedPosition.x, savedPosition.y)
        if (attempt < 12) {
          setTimeout(() => apply(attempt + 1), 150)
        } else {
          resolve(savedPosition)
        }
      }
      apply(0)
    })
  }
})

export default router
